/* tslint:disable */
/* eslint-disable */
/**
 * Rapurc API-spec
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Building owner contact person object
 * @export
 * @interface ContactPerson
 */
export interface ContactPerson {
    /**
     * Contact persons first name
     * @type {string}
     * @memberof ContactPerson
     */
    firstName?: string;
    /**
     * Contact persons last name
     * @type {string}
     * @memberof ContactPerson
     */
    lastName?: string;
    /**
     * Contact persons phone number
     * @type {string}
     * @memberof ContactPerson
     */
    phone?: string;
    /**
     * Contact persons email
     * @type {string}
     * @memberof ContactPerson
     */
    email?: string;
    /**
     * Contact persons profession
     * @type {string}
     * @memberof ContactPerson
     */
    profession?: string;
}

export function ContactPersonFromJSON(json: any): ContactPerson {
    return ContactPersonFromJSONTyped(json, false);
}

export function ContactPersonFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactPerson {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'lastName': !exists(json, 'LastName') ? undefined : json['LastName'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'profession': !exists(json, 'profession') ? undefined : json['profession'],
    };
}

export function ContactPersonToJSON(value?: ContactPerson | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'firstName': value.firstName,
        'LastName': value.lastName,
        'phone': value.phone,
        'email': value.email,
        'profession': value.profession,
    };
}


